import { types } from "../../duck";

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const Column = <TValue extends any = any, TRecord extends any = any>(
  // eslint-disable-next-line
  props: types.ColumnProps<TValue, TRecord>
) => null;

export default Column;
